import { AIA_HDF_IDS, GE_HDF_IDS, AVIVA_HDF_IDS, PRUDENTIAL_HDF_IDS, AXA_HDF_IDS } from "./constants";

/**
 * Get HDF Id from route url
 * @param  {object} location
 * @return {string}
 */
export const getHDFId = ({ pathname }) => {
  const ids = [
    ...AIA_HDF_IDS,
    ...GE_HDF_IDS,
    ...AVIVA_HDF_IDS,
    ...PRUDENTIAL_HDF_IDS,
    ...AXA_HDF_IDS
    // PRUDENTIAL_HDF_ID,
    // TOKIOMARINE_HDF_ID,
  ].join("|");
  const regex = new RegExp(ids);
  const match = pathname.match(regex);

  return match[0];
};



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/utils.js